<template>
  <el-container>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="factorys"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="delAllAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="工厂编号">
              <el-input v-model.trim="filter.factoryNo" placeholder="请输入工厂编号" clearable/>
            </el-form-item>
            <el-form-item label="工厂名称">
              <el-input v-model.trim="filter.factoryName" placeholder="请输入工厂名称" clearable/>
            </el-form-item>
            <el-form-item label="工厂地址">
              <el-input v-model.trim="filter.address" placeholder="请输入工厂地址" clearable/>
            </el-form-item>
          </el-form>
        </template>
        <el-table-column type="selection" align="center" width="55" prop="selection"/>
        <el-table-column prop="factoryNo" align="center" label="工厂编号" width="120"/>
        <el-table-column prop="factoryName" align="left" show-overflow-tooltip label="工厂名称"/>
        <el-table-column prop="address" align="left" label="工厂地址" show-overflow-tooltip/>
        <el-table-column
            prop="shortName"
            width="200"
            align="left"
            label="工厂简称"
            show-overflow-tooltip/>
        <el-table-column prop="creatorName" align="center" label="创建人" width="120"/>
        <el-table-column prop="createTime" align="center" label="创建时间" width="150"/>
        <el-table-column
            label="操作"
            align="center"
            prop="action"
            width="120"
            fixed="right">
          <template slot-scope="scope">
            <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.pkId)"> 编辑 </el-button>
            <el-button v-if="delAuth" type="danger" @click="deleteRow(scope.row.pkId)"> 删除 </el-button>
          </template>
        </el-table-column>
      </view-table>
      <factory-edit ref="editPage" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import FactoryEdit from "@/views/information/Factory/FactoryEdit";
  export default {
    name: "FactoryList",
    components: { FactoryEdit, ViewTable },
    data() {
      return {
        limits:{
          addAuth: this.$auth(163),
          editAuth: this.$auth(165),
          delAuth: this.$auth(166),
        },
        delAllAuth: this.$auth(164),
        selection: [],
        filter: {
          factoryNo:"",
          factoryName:"",
          address:"",
        },
        columnsProperty:[
          {
            key:"factoryNo",
            align:"center",
            width:120,
          },
          {
            key:"factoryName",
            align:"left",
            tooltip:true,
          },
          {
            key:"address",
            align:"left",
            tooltip:true,
          },
          {
            key:"shortName",
            align:"left",
            tooltip:true,
          },
          {
            key:"creatorName",
            align:"center",
            width:100,
          },
          {
            key:"createTime",
            align:"center",
            width:160,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },

      deleteHandle(row) {
        this.$http.delete("basic", "factorys", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "factorys/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
